import * as React from 'react';

interface Props {
  className?: string;
  active?: boolean;
  activeColor?: string;
  inactiveColor?: string;
}

export class PhoneSVG extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { active, activeColor = '#1c1c1c', inactiveColor = '#b9b9b9' } = this.props;
    return (
      <svg width="12" height="22" viewBox="0 0 12 22" xmlns="http://www.w3.org/2000/svg">
        <g fill={active ? activeColor : inactiveColor} fillRule="evenodd">
          <path d="M1 3.001V19C1 20.105 1.894 21 2.997 21h6.006A2 2 0 0 0 11 18.999V3A1.999 1.999 0 0 0 9.003 1H2.997A2 2 0 0 0 1 3.001zm-1 0A3 3 0 0 1 2.997 0h6.006A2.999 2.999 0 0 1 12 3.001V19A3 3 0 0 1 9.003 22H2.997A2.999 2.999 0 0 1 0 18.999V3z" />
          <path d="M5 18h2v2H5z" />
        </g>
      </svg>
    );
  }
}
